import Layout from "@/app/common-modules/layout/Layout";

const helpRouter = [
  {
    path: "/helpAndSupport",
    component: Layout,
    redirect: "/helpAndSupport/helpCenter",
    name: "helpAndSupport",
    children: [
      {
        path: "/helpAndSupport/helpCenter",
        component: () => import("@/app/helpAndSupport/views/help-center"),
        name: "helpCenter"
      },
      {
        path: "/helpAndSupport/helpManual",
        component: () =>
          import("@/app/helpAndSupport/views/manual/help-apply-usersmanual"),
        name: "helpManual"
      },
      {
        path: "/helpAndSupport/helpProblem",
        component: () =>
          import("@/app/helpAndSupport/views/problem/problem-edit-dic"),
        name: "helpProblem"
      }
    ]
  }
];

export default helpRouter;
